import { render, staticRenderFns } from "./EiCouponDetail.vue?vue&type=template&id=2603d3c2&scoped=true&"
import script from "./EiCouponDetail.vue?vue&type=script&lang=js&"
export * from "./EiCouponDetail.vue?vue&type=script&lang=js&"
import style0 from "./EiCouponDetail.vue?vue&type=style&index=0&id=2603d3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603d3c2",
  null
  
)

component.options.__file = "EiCouponDetail.vue"
export default component.exports